import React, {useState} from "react";
import styled from "styled-components";
import PageHeader from "../../components/organisms/PageHeader";
import Table from "../../components/molecules/Table"
import tour1 from "../../assets/images/tour_01.jpg";
import tour2 from "../../assets/images/tour_02.jpg";
import tour3 from "../../assets/images/tour_03.jpg";
import Btn from "../../components/atoms/Btn";
import Modal from "../../components/organisms/Modal";
import ReservationModal from "../../components/templates/ReservationModal";
import {device} from "../../assets/styles/media";

const Contents = styled.div`
    margin-bottom: 140px;
    
    img:first-child {
        height: 554px;
    }
    img {
        display: block;
        vertical-align: top;
        ${device.tablet} {
          margin-bottom: 30px;
        }
    }
    
    ${device.tablet} {
        section {
            flex-direction: column;
            flex: 1;
        }

        section:nth-child(2){
            flex-direction: column-reverse;
        }
    }

    ${device.mobile} {
        margin-top: 30px;
        margin-bottom: 50px;
        img:first-child,
        img{
            height: 260px;
        }
        section {
            flex-direction: column;
            flex: 1;
        }

        section:nth-child(2){
            flex-direction: column-reverse;
        }
    }
    
`;
const Section = styled.section`
    margin-bottom: 160px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 10px;
    box-sizing: border-box;

    div:last-child {
        display: flex;
        flex-direction: column;
        flex: 1;
    }

    ${device.tablet} {
       align-items: center;
        margin-bottom: 120px;
    }
    ${device.mobile} {
        margin-bottom: 50px;
    }
`;
const TourSection = styled.section`
    display: flex;
    padding: 10px;
    box-sizing: border-box;
    margin-bottom: 50px;
`;

const TourBox = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    ${device.tablet} {
        flex-direction: column;
        flex: 1;
         align-items: center;
    }
    ${device.mobile} {
        flex-direction: column;
    }
`;
const TourImage = styled.img`
    display: block;
    width: 630px;
    aspect-ratio: 630 / 577; /* 또는 원본 비율 계산해서 적용 */
    object-fit: cover;
    
    ${device.mobile}{
        width: 100%;
        aspect-ratio: 630 / 577;
        margin-bottom: 20px;
    }
`;

const TourContent = styled.div`
    width: 630px;
    height: 100%;
    ${({position}) => position === "left" ? "margin-left: 100px;" : "margin-right: 100px;"};
    color: #444;
    
    span {
        font-weight: 400;
    }

    ${device.tablet} {
        margin-right: 0;
        margin-left: 0;
    } ;

    ${device.mobile} {
        width:100%; ${({position}) => position === "left" ? "margin-left: 0px;" : "margin-right: 0px;"};
    } ;
}
`;

const GroupGuide = () => {
    const [openModal, setOpenModal] = useState(false);
    const headers = [
        {
            name: "구분",
            width: "28%"
        },
        {
            name: "내용",
            width: "72%"
        },
    ];
    const data = [
        ["소요시간", "약 40~50분"],
        ["대상", "1인 이상 개별 관람객"],
        ["투어 장소", "강아지숲 박물관 내부"],
        ["투어 내용", "강아지숲 소개 / 특별전시 및 상설전시 해설"],
    ];
    const text1 = ['개별 투어는 매주 주말 운영되며 온라인으로 신청시 11:00, 13:00, 15:00 중 한 타임을 선택하여 예약하실 수 있습니다.',
        <span> 1명 이상 예약시 진행됩니다. 방문 예정일로부터 3일 전까지 온라인 신청이 가능합니다.</span>]

    const data2 = [
        ["소요시간", "약 1시간"],
        ["대상", "어린이집, 유치원 (최대 35명)"],
        ["투어 장소", "박물관 내부 전시장"],
        ["투어 내용", "전시해설, 반려견 에티켓 교육"],
    ];
    const text2 = ['어린이집/ 유치원 프로그램은 단체 예약(할인혜택)을 신청한 어린이집 또는 유치원에 한해서 진행할 수 있습니다.' ,
    '예약한 단체 중 선착순으로 신청을 받으며',
    <span> 일정이 중복될 시 </span> ,
    '신청이 불가할 수 있습니다. 프로그램 참여를 희망하는 날로부터 5일 전까지 온라인 신청이 가능합니다.'];
    const text3 = ['단체 예약은 20인 이상 신청 가능하며, 입장료의 20%가 할인 적용됩니다. 방문 예정일로부터 7일 전까지 온라인 신청이 가능합니다.',
        '단체 예약을 신청한 팀은 박물관 투어를 신청할 수 있으며, 투어는 예약한 단체 중 선착순으로 신청을 받으며' ,
         <span> 일정이 중복될 시 신청이 불가할 수 있습니다.</span>];

    const data3 = [
        ["소요시간", "약 40~50분"],
        ["대상", "단체 예약팀(최대 35명)"],
        ["투어 장소", "박물관 내부 전시장"],
        ["투어 내용", "강아지숲 소개 / 특별전시 및 상설전시 해설"],
    ];


    return (
        <>
            <PageHeader
                bTitle="이용안내"
                detail="단체 예약 안내"
                desc="강아지숲 단체 예약을 안내해 드립니다."
            />

            <Contents>
                {/*박물관 투어*/}
                <Section>
                    <TourImage src={tour1} alt="박물관 투어 이미지"/>
                    <TourContent position={"left"}>
                        <Table subTitle="박물관 투어" headers={headers} data={data} text={text1}/>
                    </TourContent>
                </Section>


                {/*어린이집/유치원 프로그램*/}
                <Section>
                    <TourContent position={"right"}>
                        <Table subTitle="어린이집/유치원 프로그램" headers={headers} data={data2} text={text2}/>
                    </TourContent>
                    <TourImage src={tour2} alt="박물관 투어 이미지"/>
                </Section>


                {/*/!*  단체 예약 및 단체 투어*!/*/}
                <TourSection>
                    <TourBox>
                        <TourImage src={tour3} alt="박물관 투어 이미지"/>
                        <TourContent position={"left"}>
                            <Table subTitle="단체 예약 및 단체 투어" headers={headers} data={data3} text={text3}/>
                        </TourContent>
                    </TourBox>
                </TourSection>
                <Btn text={"투어 및 단체 예약"}
                     onClick={() => setOpenModal(true)}
                />
            </Contents>

            {openModal &&
                <Modal
                    title={"투어 및 단체 예약"}
                    open={openModal}
                    setOpenModal={setOpenModal}
                    content={<ReservationModal setOpenModal={setOpenModal}/>}
                />
            }
        </>
    );
};

export default GroupGuide;
